import { render, staticRenderFns } from "./SensorChart.vue?vue&type=template&id=1520db76&"
import script from "./SensorChart.vue?vue&type=script&lang=js&"
export * from "./SensorChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports